module.exports = __webpack_public_path__ + "img/1716350096408-WhatsApp Image 2024-05-22 at 10.39.05.jpeg.2133fd4c.webp";